import { MainImages } from '@lemon/assets';
import { ImageList } from '../../common/Image';

export const Customer = () => {
    return (
        <figure
            className="relative w-full h-full flex flex-col items-center text-left justify-center bg-white text-black
		  px-6 py-10 gap-5 md:px-16 md:py-20 md:gap-10 xl:px-32 xl:py-40"
        >
            <img src={MainImages.customer} alt="Customer" onDragStart={e => e.preventDefault()} />

            <h6 className="text-2xl font-bold text-left w-full">{title}</h6>
            <div className="flex flex-col gap-3 md:gap-4 text-[16px] md:text-[20px] lg:text-[24px] text-pretty leading-relaxed max-w-[1000px] w-full">
                <p>{description1}</p>
                <p>{description2}</p>
                <p>{description3}</p>
            </div>

            <ImageList images={images} />
        </figure>
    );
};

const title = '개인 맞춤형 뷰티 경험';
const description1 = `파우치 속 제품을 등록하여 자신의 메이크업 성향을 분석할 수 있습니다.`;
const description2 = `또한 유사한 취향을 가진 다른 사용자의 파우치를 탐색하며 새로운 아이템을 발견하고,`;
const description3 = `개인에게 최적화된 제품 추천을 받을 수 있습니다.`;
const images = [MainImages.customer_l, MainImages.customer_r];
